import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { OrderGoodsItemDto } from '../../api/ClientApi';
import { WarehouseClient } from '../../api/Extensions';

export const addOrUpdateOrderGoodsItem = createAction<OrderGoodsItemDto>('orderGoodsItems/addOrUpdateOrderGoodsItem');

export const importApprovedOrderGoodsItems = createAsyncThunk<OrderGoodsItemDto[]>(
    'orderGoodsItems/importApprovedOrderGoodsItems',
    async (payload, thunkAPI) => {
        return WarehouseClient.getAllApprovedOrderOrderGoodsItems();
    },
);
